import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ADIProductDescription from "@NA/Components/RecentlyPurchasedProduct/ADIProductDescription";
import ADIProductImage from "@NA/Components/RecentlyPurchasedProduct/ADIProductImage";
import ADIProductSaleInfo from "@NA/Components/ProductList/ADIProductSaleInfo";
import React, { FC, useEffect, useState } from "react";
import { ResolveThunks, connect, useSelector } from "react-redux";
import { css } from "styled-components";
import ProductComapreCheckbox, {
    ProductComapreCheckboxStyles,
} from "@NA/Widgets/ProductCompare/ProductCompareCheckbox";
import ADIProductBrandName from "@NA/Components/RecentlyPurchasedProduct/ADIProductBrandName";
import ADIProductPartNumbers from "@NA/Components/RecentlyPurchasedProduct/ADIProductPartNumbers";
import ADIProductDeliveryInfo from "@NA/Components/RecentlyPurchasedProduct/ADIProductDeliveryInfo";
import ADIProductAvailability from "@NA/Components/RecentlyPurchasedProduct/ADIProductAvailability";
import ADIProductAddToCartButton, {
    AdiProductAddToCartButtonStyles,
} from "@NA/Components/RecentlyPurchasedProduct/ADIProductAddToCartButton";
import ADIColors from "@NA/Utils/ADIColors";
import ADIRecentlyViewedProductPrice, {
    ADIProductPriceStyles,
    adiProductPriceStyles,
} from "@NA/Components/ADIRecentlyViewedProductPrice";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getProp } from "@insite/mobius/utilities";
import toggleLoginDrawer from "@NA/Handlers/ADILoginDrawerHandler";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import Link from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import siteMessage from "@insite/client-framework/SiteMessage";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import CrossIcon from "@NA/Icons/CrossIcon";
import { recentlyViewedInfoById } from "@NA/Store/Selector/ADIRecentlyViewedSelector";
import { pushDealerAuthDataToDataLayer } from "@NA/Overrides/Common/Utilities/CustomTracking";
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import updateProductInfo from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/UpdateProductInfo";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import ADIRecenlyViewedProductAddToCartButton from "@NA/Overrides/Components/ADIRecenlyViewedProductAddToCartButton";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { isPriceAvailable } from "@NA/Utils/Utility";
import { productCarouselProductStyles } from "@NA/Components/ProductDetail/ADIProductCarouselStyles";
import { getMaxProductHeight } from "@NA/Utils/Utility";
interface OwnProps {
    carouselId: string;
    product: any;
    view: string;
    showBrand: boolean;
    showPartNumbers: boolean;
    showPrice: boolean;
    showAvailability: boolean;
    //extendedStyles?: ADIProductGridCardStyles;
    isAdiChoice?: boolean;
    PendingAccountverificationCreditStatus?: string | null;

}

const mapStateToProps = (state: CustomApplicationState, ownProps: OwnProps) => {
    const adiUserRoles = state.ADIGlobalData.ADIUserRoleStore;
    const session = getSession(state);
    let customerNumber = "";
    const billToId = session?.billToId;
    if (billToId) {
        customerNumber = state.data.billTos.byId[billToId]?.customerNumber;
    }
    return {
        productSettings: getSettingsCollection(state).productSettings,
        isAuthenticated: state.context.session.isAuthenticated,
        session,
        state,
        pageType: getCurrentPage(state).type,
        catalogUrlPath: state.context.settings.settingsCollection.productSettings.catalogUrlPath,
        showADIAddToCart: (adiUserRoles.fullAccess && adiUserRoles.accounting) || adiUserRoles.fullAccess,
        productInfo: recentlyViewedInfoById(state, ownProps.product.id),
        customerNumber,
    };
};

const mapDispatchToProps = {
    toggleLoginDrawer,
    updateProductInfo,
};

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;
interface RecentlyViewStyles {
    addToCartContainer?: InjectableCss;
    cartPartNumberGridItem?: InjectableCss;
    cartAvailabilityGridItem?: GridItemProps;
    brandGridItem?: GridItemProps;
    wrapper?: InjectableCss;
    dealerCertificationWrapper?: InjectableCss
}
const recentlyViewStyles: RecentlyViewStyles = {
    addToCartContainer: {
        css: css`
            width: 100%;
            @media screen and (max-width: 767px) {
                width: 166%;
                margin-left: -66%;
                [class^="FormFieldStyle-"] [class^="FormInputWrapper-"] {
                    margin-top: 0px !important;
                }
                > div {
                    padding: 0px;
                    button {
                        border-top: 1px solid #ececec !important;
                        justify-content: center;
                    }
                }
            }
        `,
    },
    cartPartNumberGridItem: {
        css: css`
            line-height: 1;
        `,
    },
    brandGridItem: {
        css: css`
            padding-left: 15px;
        `,
    },
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            overflow: hidden;
            border: 1px solid ${getColor("text.disabled")};
            border-radius: 5px;
            position: relative;
            background: ${ADIColors.white};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: flex;
                        align-items: flex-start;
                        flex-flow: row;
                        //padding-bottom:70px;
                    `,
                    css`
                        display: flex;
                        align-items: flex-start;
                        flex-flow: row;
                        //padding-bottom:70px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    dealerCertificationWrapper: {
        css: css`
            border-top: solid 1px ${ADIColors.gray7};
            text-align: center;
            padding: 6.5px 4px !important;
            height: 55px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            &.productListView {
                border-top: none;
                justify-content: flex-start;
                align-items: flex-start;
                > div:first-child {
                    font-weight: 600;
                }
                > button > span {
                    padding-top: 10px;
                }
            }
        `,
    },
};

const styles = productCarouselProductStyles;

const ADIRecentlyViewedProductGridCard: React.FC<Props> = ({
    carouselId,
    product,
    view,
    showBrand,
    showPartNumbers,
    showPrice,
    toggleLoginDrawer,
    updateProductInfo,
    showAvailability,
    productSettings,
    //extendedStyles,
    isAuthenticated,
    session,
    pageType,
    state,
    catalogUrlPath,
    showADIAddToCart,
    customerNumber,
    isAdiChoice,
    PendingAccountverificationCreditStatus
}) => {
    const productInfo = isAdiChoice
        ? state.ADIGlobalData.ADIChoiceGlobalProductsStore.globalProductInfosByLineId &&
        state.ADIGlobalData.ADIChoiceGlobalProductsStore.globalProductInfosByLineId[product.id]
        : recentlyViewedInfoById(state, product.id);
    const catalogRootPath = catalogUrlPath.endsWith("/") ? catalogUrlPath.slice(0, -1) : catalogUrlPath;
    const [dealerModalIsOpen, setDealerModalIsOpen] = React.useState(false);
    let adiChoiceProductInfo;
    let adiChoiceProductInfoID;
    const [minDescHeight, setMinDescHeight] = useState(15);
    const [minPartHeight, setMinPartHeight] = useState(14);
    const [minPriceHeight, setMinPriceHeight] = useState(40);
    const [minStockHeight, setMinStockHeight] = useState(15);
    const [minDelivaryInfoHeight, setMinDelivaryInfoHeight] = useState(40);

    const [minMobLeftHeight, setMinMobLeftHeight] = useState(0);
    const [minMobRightHeight, setMinMobRightHeight] = useState(0);
    const isPendingVerification = useSelector(
        (state: CustomApplicationState) => state.ADIGlobalData.PricingStatusStore.isPendingVerification,
    );

    useEffect(() => {
        const maxDescHeight = getMaxProductHeight('[data-test-selector="recentlyViewDescriptionLink"]');
        const maxPartHeight = getMaxProductHeight('[data-test-selector="plpPartNumber"]');
        const maxPriceHeight = getMaxProductHeight('[data-test-selector="recentlyViewProductPrice"]');
        const maxStockAvailableHeight = getMaxProductHeight('[data-test-selector="recentlyViewStockAvailable"]');
        const maxDeliveryInfoHeight = getMaxProductHeight('[data-test-selector="recentlyViewProductDeliveryInfo"]');

        const maxMobLeftHeight = getMaxProductHeightMob('[data-test-selector="maxMobLeftHeight"]');
        const maxMobRightHeight = getMaxProductHeightMob('[data-test-selector="maxMobRightHeight"]');

        setMinDescHeight(maxDescHeight);
        setMinPartHeight(maxPartHeight);
        setMinPriceHeight(maxPriceHeight);
        setMinStockHeight(maxStockAvailableHeight);
        setMinDelivaryInfoHeight(maxDeliveryInfoHeight);

        if (window.innerWidth < 767) {
            setMinMobLeftHeight(maxMobLeftHeight);
            setMinMobRightHeight(maxMobRightHeight);
        }
    }, [showPrice]);

    if (productInfo !== undefined && (productInfo as ProductInfo)) {
        adiChoiceProductInfoID = productInfo.productId;
        adiChoiceProductInfo = productInfo;
    }
    if (!product || !productInfo) {
        return null;
    }
    const freeShippingAmount = Number(session.properties.freeshipThresholdAmt);
    const pricing = productInfo?.pricing || product.pricing;
    const updateQuantity = (qtyOrdered: number) => {
        updateProductInfo({ id: carouselId, productId: product.id, qtyOrdered });
    };

    const updateUnitOfMeasure = (unitOfMeasure: string) => {
        updateProductInfo({ id: carouselId, productId: product.id, unitOfMeasure });
    };
    const productContext = {
        product,
        productInfo,
        onUnitOfMeasureChanged: updateUnitOfMeasure,
        onQtyOrderedChanged: updateQuantity,
    };
    const qtyOrdered = product.qtyOrdered;
    const pricingIsAvailable = isPriceAvailable(pricing, qtyOrdered);
    const openSignIn = () => {
        toggleLoginDrawer({
            loginDrawer: true,
        });
    };

    const getCertified = () => {
        setDealerModalIsOpen(true);
    };

    const dealerModalCloseHandler = () => {
        setDealerModalIsOpen(false);
    };

    const showAuthorizationRequired =
        pricing &&
            pricing.additionalResults &&
            pricing.additionalResults.isVisible &&
            pricing.additionalResults.isVisible === "N"
            ? "true"
            : "false";
    const vendorAuthRequiredList = product?.properties?.vendorAuthRequiredList?.toLowerCase();
    const brandName = product.brand?.name ?? "";
    const vendorAuthRequiredLink = product?.properties?.vendorAuthRequiredLink;
    const clickHandler = () => {
        pushDealerAuthDataToDataLayer(brandName, vendorAuthRequiredLink, customerNumber, "Recently Viewed", session);
    };

    const getMaxProductHeightMob = (selector: string): number => {
        const itemProductHeight = document.querySelectorAll(selector);

        let maxProductHeight = 10;

        if (window.innerWidth < 767) {
            itemProductHeight.forEach(item => {
                maxProductHeight = Math.max(maxProductHeight, item.clientHeight);
            });
        }

        return maxProductHeight;
    };
    return (
        <>
            <ProductContext.Provider value={productContext}>
                {pageType === "ProductDetailsPage" ? (
                    <StyledWrapper {...styles.wrapper} data-test-selector={`productGridProductCard${product.id}`}>
                        <ADIProductSaleInfo product={product} isAuthenticated={isAuthenticated} pricing={pricing} />

                        <StyledWrapper
                            {...styles.mobLeftSideContainer}
                            style={{ maxHeight: minMobLeftHeight > 0 ? minMobLeftHeight + "px" : "initial" }}
                            data-test-selector="maxMobLeftHeight"
                        >
                            {pageType === "ProductDetailsPage" ? (
                                <ProductComapreCheckbox extendedStyles={styles.productComapreCheckboxStyles} />
                            ) : (
                                ""
                            )}
                            <StyledWrapper {...styles.imageWrapper}>
                                <ADIProductImage product={product} sourceName="Recently Viewed" />
                                <StyledWrapper {...styles.mobProdPartNumbers}>
                                    <ADIProductPartNumbers product={product} view={view} />
                                </StyledWrapper>
                            </StyledWrapper>
                        </StyledWrapper>

                        <StyledWrapper
                            {...styles.mobRightSideContainer}
                            style={{ maxHeight: minMobRightHeight > 0 ? minMobRightHeight + "px" : "initial" }}
                            data-test-selector="maxMobRightHeight"
                        >
                            <StyledWrapper {...styles.imageWrapper}>
                                {product.isSponsored && (
                                    <Typography {...styles.sponsoredText}>{translate("Sponsored")}</Typography>
                                )}
                            </StyledWrapper>
                            <StyledWrapper {...styles.contentWrapper}>
                                <GridContainer>
                                    {product.brand && showBrand && (
                                        <GridItem {...styles.brandGridItem}>
                                            <ADIProductBrandName
                                                brandName={product?.brand?.name || product?.properties?.branD_SHORTDESC} // P21 change
                                                //brandName={product?.brand?.name} 
                                                brandUrl={catalogRootPath + product.brand?.detailPagePath}
                                                extendedStyles={styles.brandStyles}
                                            />
                                        </GridItem>
                                    )}
                                    <GridItem
                                        {...styles.productDescriptionContainer}
                                        data-test-selector="recentlyViewDescriptionLink"
                                        style={{ minHeight: minDescHeight + "px" }}
                                    >
                                        <ADIProductDescription
                                            session={session}
                                            sourceName="Recently Viewed"
                                            product={product}
                                            {...styles.descriptionStyles}
                                        />
                                    </GridItem>
                                    {showPartNumbers && (
                                        <GridItem
                                            {...styles.productPartNumbersContainer}
                                            data-test-selector="plpPartNumber"
                                            style={{ minHeight: minPartHeight + "px" }}
                                        >
                                            <ADIProductPartNumbers product={product} view={view} />
                                        </GridItem>
                                    )}
                                    {PendingAccountverificationCreditStatus !== "O" && PendingAccountverificationCreditStatus !== "" && PendingAccountverificationCreditStatus !== null ?
                                        ""
                                        :

                                        (<>
                                            {showPrice && session.isAuthenticated && (
                                                <GridItem
                                                    {...styles.priceGridItem}
                                                    style={{ minHeight: minPriceHeight + "px" }}
                                                    data-test-selector="recentlyViewProductPrice"
                                                >
                                                    <ADIRecentlyViewedProductPrice
                                                        product={product}
                                                        showSavings={true}
                                                        showUnitOfMeasure={false}
                                                        showSavingsAmount={productSettings.showSavingsAmount}
                                                        showSavingsPercent={productSettings.showSavingsPercent}
                                                    />
                                                </GridItem>
                                            )}
                                            {session.isAuthenticated && (
                                                <GridItem
                                                    {...styles.deliveryMsgGridItem}
                                                    style={{ minHeight: minDelivaryInfoHeight + "px" }}
                                                    data-test-selector="recentlyViewProductDeliveryInfo"
                                                >
                                                    <ADIProductDeliveryInfo
                                                        product={product}
                                                        freeShippingAmount={freeShippingAmount}
                                                        showAuthorizationRequired={showAuthorizationRequired}
                                                    />
                                                </GridItem>
                                            )}

                                            {session.isAuthenticated && (
                                                <GridItem
                                                    {...styles.availabilityGridItem}
                                                    data-test-selector="recentlyViewStockAvailable"
                                                    style={{ minHeight: minStockHeight + "px" }}
                                                >
                                                    <ADIProductAvailability
                                                        product={product}
                                                        view={view}
                                                        showAuthorizationRequired={showAuthorizationRequired}
                                                    />
                                                </GridItem>
                                            )}

                                            {session.isAuthenticated &&
                                                showAuthorizationRequired === "true" &&
                                                !isPendingVerification &&
                                                vendorAuthRequiredList === "false" ? (
                                                <StyledWrapper {...styles.showAuthContainer}>
                                                    <StyledWrapper {...styles.showAuthInnerContainer}>
                                                        {
                                                            PendingAccountverificationCreditStatus !== "O" && PendingAccountverificationCreditStatus !== "" && PendingAccountverificationCreditStatus !== null ? <Typography {...styles.VerificationText} as="span">{translate("Account Pending Verification")}</Typography> :
                                                                <>
                                                                    <StyledWrapper {...styles.stylesdealerTitle}>
                                                                        Dealer Certification Required
                                                                    </StyledWrapper>
                                                                    <Link {...styles.getCertifiedText} onClick={getCertified}>
                                                                        Get Certified
                                                                    </Link>
                                                                </>
                                                        }

                                                        <Modal
                                                            {...styles.dealerCertificationModal}
                                                            headline={translate("Dealer Certification Required")}
                                                            isOpen={dealerModalIsOpen}
                                                            handleClose={dealerModalCloseHandler}
                                                        >
                                                            <StyledWrapper {...styles.dealerMsg}>
                                                                {siteMessage("Dealer_Certification_Message")}
                                                            </StyledWrapper>
                                                            <Button onClick={dealerModalCloseHandler} {...styles.continue}>
                                                                Continue Shopping
                                                            </Button>
                                                        </Modal>
                                                    </StyledWrapper>
                                                </StyledWrapper>
                                            ) : session.isAuthenticated &&
                                                showAuthorizationRequired === "true" &&
                                                !isPendingVerification &&
                                                vendorAuthRequiredList === "true" ? (
                                                <StyledWrapper {...styles.showAuthContainer}>
                                                    <StyledWrapper {...styles.showAuthInnerContainer}>
                                                        {
                                                            PendingAccountverificationCreditStatus !== "O" && PendingAccountverificationCreditStatus !== "" && PendingAccountverificationCreditStatus !== null ? <Typography {...styles.VerificationText} as="span">{translate("Account Pending Verification")}</Typography> :
                                                                <>
                                                                    <StyledWrapper {...styles.stylesdealerTitle}>
                                                                        Dealer Certification Required
                                                                    </StyledWrapper>
                                                                    <Link {...styles.getCertifiedText} onClick={getCertified}>
                                                                        Get Certified
                                                                    </Link>
                                                                </>
                                                        }

                                                        <Modal
                                                            {...styles.dealerCertificationModal}
                                                            headline={translate("Dealer Certification Required")}
                                                            isOpen={dealerModalIsOpen}
                                                            handleClose={dealerModalCloseHandler}
                                                        >
                                                            <StyledWrapper {...styles.dealerMsg}>
                                                                {siteMessage("Dealer_Vendor_Certification_Message")}
                                                                <Link
                                                                    href={product.properties?.vendorAuthRequiredLink}
                                                                    target="_blank"
                                                                    onClick={clickHandler}
                                                                    {...styles.vendorLink}
                                                                >
                                                                    {" "}
                                                                    {translate(" vendor's form.")}
                                                                </Link>{" "}
                                                                {translate("For more information, call ")}
                                                                <StyledWrapper as="span">1.877.228.6739.</StyledWrapper>
                                                            </StyledWrapper>
                                                            <Button onClick={dealerModalCloseHandler} {...styles.continue}>
                                                                Continue Shopping
                                                            </Button>
                                                        </Modal>
                                                    </StyledWrapper>
                                                </StyledWrapper>
                                            ) : (
                                                <>
                                                    {pricingIsAvailable && session.isAuthenticated && showADIAddToCart && (
                                                        <StyledWrapper {...recentlyViewStyles.addToCartContainer}>
                                                            <GridItem {...styles.addToCartGridItem}>
                                                                <ADIProductAddToCartButton
                                                                    productLine={product}
                                                                    buttonLabel="Add To Cart"
                                                                    recentViewed={true}
                                                                    extendedStyles={styles.addToCartStyles}
                                                                    sourceName="Recently Viewed"
                                                                />
                                                            </GridItem>
                                                        </StyledWrapper>
                                                    )}
                                                </>
                                            )}

                                            {!session.isAuthenticated && (
                                                <GridItem {...styles.addToCartContainerWithoutSignIn}>
                                                    <StyledWrapper {...styles.signInDealerPrice} onClick={openSignIn}>
                                                        <Typography {...styles.dealerPriceText} as="span">
                                                            {translate("Sign In for Dealer Pricing")}
                                                        </Typography>
                                                    </StyledWrapper>
                                                </GridItem>
                                            )}
                                            {session.isAuthenticated && isPendingVerification && (
                                                <GridItem {...styles.pendingVerificationParent}>
                                                    <StyledWrapper {...styles.pendingVerification}>
                                                        <Typography {...styles.pendingVerificationText} as="span">
                                                            {translate("Account Pending Verification")}
                                                        </Typography>
                                                    </StyledWrapper>
                                                </GridItem>
                                            )}
                                        </>)}
                                </GridContainer>
                            </StyledWrapper>
                        </StyledWrapper>
                        {PendingAccountverificationCreditStatus !== "O" && PendingAccountverificationCreditStatus !== "" && PendingAccountverificationCreditStatus !== null ?
                            <StyledWrapper
                                {...styles.dealerCertificationWrapper}

                            >

                                <Typography {...styles.VerificationText} as="span">{translate("Account Pending Verification")}</Typography>
                            </StyledWrapper>
                            : <>
                                {session.isAuthenticated &&
                                    showAuthorizationRequired === "true" &&
                                    !isPendingVerification &&
                                    vendorAuthRequiredList === "false" ? (
                                    <StyledWrapper {...styles.showDesktopAuthContainer}>
                                        <StyledWrapper {...styles.showAuthInnerContainer}>
                                            {PendingAccountverificationCreditStatus !== "O" && PendingAccountverificationCreditStatus !== "" && PendingAccountverificationCreditStatus !== null ? <Typography {...styles.VerificationText} as="span">{translate("Account Pending Verification")}</Typography> :
                                                <>
                                                    <StyledWrapper {...styles.stylesdealerTitle}>
                                                        Dealer Certification Required
                                                    </StyledWrapper>
                                                    <Link {...styles.getCertifiedText} onClick={getCertified}>
                                                        Get Certified
                                                    </Link>
                                                </>}
                                            <Modal
                                                {...styles.dealerCertificationModal}
                                                headline={translate("Dealer Certification Required")}
                                                isOpen={dealerModalIsOpen}
                                                handleClose={dealerModalCloseHandler}
                                            >
                                                <StyledWrapper {...styles.dealerMsg}>
                                                    {siteMessage("Dealer_Certification_Message")}
                                                </StyledWrapper>
                                                <Button onClick={dealerModalCloseHandler} {...styles.continue}>
                                                    Continue Shopping
                                                </Button>
                                            </Modal>
                                        </StyledWrapper>
                                    </StyledWrapper>
                                ) : session.isAuthenticated &&
                                    showAuthorizationRequired === "true" &&
                                    !isPendingVerification &&
                                    vendorAuthRequiredList === "true" ? (
                                    <StyledWrapper {...styles.showDesktopAuthContainer}>
                                        <StyledWrapper {...styles.showAuthInnerContainer}>

                                            {PendingAccountverificationCreditStatus !== "O" && PendingAccountverificationCreditStatus !== "" && PendingAccountverificationCreditStatus !== null ? <Typography {...styles.VerificationText} as="span">{translate("Account Pending Verification")}</Typography> : <>
                                                <StyledWrapper {...styles.stylesdealerTitle}>
                                                    Dealer Certification Required
                                                </StyledWrapper>
                                                <Link {...styles.getCertifiedText} onClick={getCertified}>
                                                    Get Certified
                                                </Link>
                                            </>}

                                            <Modal
                                                {...styles.dealerCertificationModal}
                                                headline={translate("Dealer Certification Required")}
                                                isOpen={dealerModalIsOpen}
                                                handleClose={dealerModalCloseHandler}
                                            >
                                                <StyledWrapper {...styles.dealerMsg}>
                                                    {siteMessage("Dealer_Vendor_Certification_Message")}
                                                    <Link
                                                        href={product.properties?.vendorAuthRequiredLink}
                                                        target="_blank"
                                                        onClick={clickHandler}
                                                        {...styles.vendorLink}
                                                    >
                                                        {" "}
                                                        {translate(" vendor's form.")}
                                                    </Link>{" "}
                                                    {translate("For more information, call ")}
                                                    <StyledWrapper as="span">1.877.228.6739.</StyledWrapper>
                                                </StyledWrapper>
                                                <Button onClick={dealerModalCloseHandler} {...styles.continue}>
                                                    Continue Shopping
                                                </Button>
                                            </Modal>
                                        </StyledWrapper>
                                    </StyledWrapper>
                                ) : null}
                            </>}
                    </StyledWrapper>
                ) : (
                    <StyledWrapper {...styles.cartWrapper} data-test-selector={`productGridProductCard${product.id}`}>
                        <ADIProductSaleInfo product={product} isAuthenticated={isAuthenticated} pricing={pricing} />

                        <StyledWrapper {...styles.cartMobLeftSideContainer}>
                            <StyledWrapper {...styles.newImageWrapper}>
                                <ADIProductImage product={product} sourceName="Recently Viewed" />
                                <StyledWrapper {...styles.cartMobProdPartNumbers}>
                                    <ADIProductPartNumbers product={product} view={view} />
                                </StyledWrapper>
                            </StyledWrapper>
                        </StyledWrapper>

                        <StyledWrapper {...styles.cartMobRightSideContainer}>
                            <StyledWrapper {...styles.imageWrapper}>
                                {product.isSponsored && (
                                    <Typography {...styles.sponsoredText}>{translate("Sponsored")}</Typography>
                                )}
                            </StyledWrapper>
                            <StyledWrapper {...styles.contentWrapper}>
                                <GridContainer>
                                    {product.brand && showBrand && (
                                        <GridItem {...styles.cartBrandGridItem}>
                                            <ADIProductBrandName
                                                brandName={product?.brand?.name || product?.properties?.branD_SHORTDESC} // P21 change
                                                //brandName={product.brand?.name} // Code from spire prod.
                                                brandUrl={catalogRootPath + product.brand?.detailPagePath}
                                                extendedStyles={styles.brandStyles}
                                            />
                                        </GridItem>
                                    )}
                                    <GridItem
                                        {...styles.cartDescriptionGridItem}
                                        data-test-selector="recentlyViewDescriptionLink"
                                        style={{ minHeight: minDescHeight + "px" }}
                                    >
                                        <ADIProductDescription
                                            sourceName="Recently Viewed"
                                            session={session}
                                            product={product}
                                        />
                                    </GridItem>
                                    {showPartNumbers && (
                                        <GridItem
                                            {...styles.cartPartNumberGridItem}
                                            data-test-selector="plpPartNumber"
                                            style={{ minHeight: minPartHeight + "px" }}
                                        >
                                            <ADIProductPartNumbers product={product} view={view} />
                                        </GridItem>
                                    )}
                                    {PendingAccountverificationCreditStatus !== "O" && PendingAccountverificationCreditStatus !== "" && PendingAccountverificationCreditStatus !== null ? 
                                    ""
                                     :
                                        (<>

                                            {showPrice && (
                                                <GridItem
                                                    {...styles.cartPriceGridItem}
                                                    style={{ minHeight: minPriceHeight + "px" }}
                                                    data-test-selector="recentlyViewProductPrice"
                                                >
                                                    <ADIRecentlyViewedProductPrice
                                                        product={product}
                                                        showSavings={true}
                                                        showUnitOfMeasure={false}
                                                        showSavingsAmount={productSettings.showSavingsAmount}
                                                        showSavingsPercent={productSettings.showSavingsPercent}
                                                        extendedStyles={adiProductPriceStyles}
                                                    />
                                                </GridItem>
                                            )}
                                            {showAvailability && (
                                                <GridItem
                                                    {...styles.cartAvailabilityGridItem}
                                                    data-test-selector="recentlyViewStockAvailable"
                                                    style={{ minHeight: minStockHeight + "px" }}
                                                >
                                                    <ADIProductAvailability
                                                        product={product}
                                                        view={view}
                                                        showAuthorizationRequired={showAuthorizationRequired}
                                                    />
                                                </GridItem>
                                            )}

                                            {session.isAuthenticated && isPendingVerification && (
                                                <GridItem {...styles.pendingVerificationParent}>
                                                    <StyledWrapper
                                                        {...styles.pendingVerification}
                                                        style={{
                                                            cursor: "auto",
                                                            border: "1px solid #ECECEC",
                                                        }}
                                                    >
                                                        <Typography {...styles.pendingVerificationText} as="span">
                                                            {translate("Account Pending Verification")}
                                                        </Typography>
                                                    </StyledWrapper>
                                                </GridItem>
                                            )}

                                            {session.isAuthenticated &&
                                                showAuthorizationRequired === "true" &&
                                                !isPendingVerification &&
                                                vendorAuthRequiredList === "false" ? (
                                                <StyledWrapper {...styles.showAuthContainer}>
                                                    <StyledWrapper {...styles.showAuthInnerContainer}>

                                                        {PendingAccountverificationCreditStatus !== "O" && PendingAccountverificationCreditStatus !== "" && PendingAccountverificationCreditStatus !== null ? <Typography {...styles.VerificationText} as="span">{translate("Account Pending Verification")}</Typography> : <>
                                                            <StyledWrapper {...styles.stylesdealerTitle}>
                                                                Dealer Certification Required
                                                            </StyledWrapper>
                                                            <Link {...styles.getCertifiedText} onClick={getCertified}>
                                                                Get Certified
                                                            </Link>
                                                        </>}

                                                        <Modal
                                                            {...styles.dealerCertificationModal}
                                                            headline={translate("Dealer Certification Required")}
                                                            isOpen={dealerModalIsOpen}
                                                            handleClose={dealerModalCloseHandler}
                                                        >
                                                            <StyledWrapper {...styles.dealerMsg}>
                                                                {siteMessage("Dealer_Certification_Message")}
                                                            </StyledWrapper>
                                                            <Button onClick={dealerModalCloseHandler} {...styles.continue}>
                                                                Continue Shopping
                                                            </Button>
                                                        </Modal>
                                                    </StyledWrapper>
                                                </StyledWrapper>
                                            ) : session.isAuthenticated &&
                                                showAuthorizationRequired === "true" &&
                                                !isPendingVerification &&
                                                vendorAuthRequiredList === "true" ? (
                                                <StyledWrapper {...styles.showAuthContainer}>
                                                    <StyledWrapper {...styles.showAuthInnerContainer}>
                                                        {PendingAccountverificationCreditStatus !== "O" && PendingAccountverificationCreditStatus !== "" && PendingAccountverificationCreditStatus !== null ? <Typography {...styles.VerificationText} as="span">{translate("Account Pending Verification")}</Typography> :
                                                            <><StyledWrapper {...styles.stylesdealerTitle}>
                                                                Dealer Certification Required
                                                            </StyledWrapper>
                                                                <Link {...styles.getCertifiedText} onClick={getCertified}>
                                                                    Get Certified
                                                                </Link>
                                                            </>
                                                        }

                                                        <Modal
                                                            {...styles.dealerCertificationModal}
                                                            headline={translate("Dealer Certification Required")}
                                                            isOpen={dealerModalIsOpen}
                                                            handleClose={dealerModalCloseHandler}
                                                        >
                                                            <StyledWrapper {...styles.dealerMsg}>
                                                                {siteMessage("Dealer_Vendor_Certification_Message")}
                                                                <Link
                                                                    href={product.properties?.vendorAuthRequiredLink}
                                                                    target="_blank"
                                                                    onClick={clickHandler}
                                                                    {...styles.vendorLink}
                                                                >
                                                                    {" "}
                                                                    {translate(" vendor's form.")}
                                                                </Link>{" "}
                                                                {translate("For more information, call ")}
                                                                <StyledWrapper as="span">1.877.228.6739.</StyledWrapper>
                                                            </StyledWrapper>
                                                            <Button onClick={dealerModalCloseHandler} {...styles.continue}>
                                                                Continue Shopping
                                                            </Button>
                                                        </Modal>
                                                    </StyledWrapper>
                                                </StyledWrapper>
                                            ) : (
                                                <>
                                                    {showADIAddToCart && pricingIsAvailable && (
                                                        <GridItem {...styles.cartPageAddToCartGridItem}>
                                                            <ADIRecenlyViewedProductAddToCartButton
                                                                extendedStyles={styles.AddToCart}
                                                            />
                                                        </GridItem>
                                                    )}
                                                </>
                                            )}
                                        </>)
                                    }
                                </GridContainer>
                            </StyledWrapper>
                        </StyledWrapper>
                        {PendingAccountverificationCreditStatus !== "O" && PendingAccountverificationCreditStatus !== "" && PendingAccountverificationCreditStatus !== null ?
                        <StyledWrapper
                                        {...styles.dealerCertificationWrapper}
                                      
                                    >

                                     <Typography {...styles.VerificationText} as="span">{translate("Account Pending Verification")}</Typography>


                                    </StyledWrapper> 
                        
                    
                        : <>
                            {session.isAuthenticated &&
                                showAuthorizationRequired === "true" &&
                                !isPendingVerification &&
                                vendorAuthRequiredList === "false" ? (
                                <StyledWrapper {...styles.showDesktopAuthContainer}>
                                    <StyledWrapper {...styles.showAuthInnerContainer}>
                                        {PendingAccountverificationCreditStatus !== "O" && PendingAccountverificationCreditStatus !== "" && PendingAccountverificationCreditStatus !== null ? <Typography {...styles.VerificationText} as="span">{translate("Account Pending Verification")}</Typography> :
                                            <><StyledWrapper {...styles.stylesdealerTitle}>
                                                Dealer Certification Required
                                            </StyledWrapper>
                                                <Link {...styles.getCertifiedText} onClick={getCertified}>
                                                    Get Certified
                                                </Link>
                                            </>
                                        }

                                        <Modal
                                            {...styles.dealerCertificationModal}
                                            headline={translate("Dealer Certification Required")}
                                            isOpen={dealerModalIsOpen}
                                            handleClose={dealerModalCloseHandler}
                                        >
                                            <StyledWrapper {...styles.dealerMsg}>
                                                {siteMessage("Dealer_Certification_Message")}
                                            </StyledWrapper>
                                            <Button onClick={dealerModalCloseHandler} {...styles.continue}>
                                                Continue Shopping
                                            </Button>
                                        </Modal>
                                    </StyledWrapper>
                                </StyledWrapper>
                            ) : session.isAuthenticated &&
                                showAuthorizationRequired === "true" &&
                                !isPendingVerification &&
                                vendorAuthRequiredList === "true" ? (
                                <StyledWrapper {...styles.showDesktopAuthContainer}>
                                    <StyledWrapper {...styles.showAuthInnerContainer}>
                                        {
                                            PendingAccountverificationCreditStatus !== "O" && PendingAccountverificationCreditStatus !== "" && PendingAccountverificationCreditStatus !== null ? <Typography {...styles.VerificationText} as="span">{translate("Account Pending Verification")}</Typography> :
                                                <>
                                                    <StyledWrapper {...styles.stylesdealerTitle}>
                                                        Dealer Certification Required
                                                    </StyledWrapper>
                                                    <Link {...styles.getCertifiedText} onClick={getCertified}>
                                                        Get Certified
                                                    </Link>
                                                </>
                                        }

                                        <Modal
                                            {...styles.dealerCertificationModal}
                                            headline={translate("Dealer Certification Required")}
                                            isOpen={dealerModalIsOpen}
                                            handleClose={dealerModalCloseHandler}
                                        >
                                            <StyledWrapper {...styles.dealerMsg}>
                                                {siteMessage("Dealer_Vendor_Certification_Message")}
                                                <Link
                                                    href={product.properties?.vendorAuthRequiredLink}
                                                    target="_blank"
                                                    onClick={clickHandler}
                                                    {...styles.vendorLink}
                                                >
                                                    {" "}
                                                    {translate(" vendor's form.")}
                                                </Link>{" "}
                                                {translate("For more information, call ")}
                                                <StyledWrapper as="span">1.877.228.6739.</StyledWrapper>
                                            </StyledWrapper>
                                            <Button onClick={dealerModalCloseHandler} {...styles.continue}>
                                                Continue Shopping
                                            </Button>
                                        </Modal>
                                    </StyledWrapper>
                                </StyledWrapper>
                            ) : null}
                        </>}
                    </StyledWrapper>
                )}
            </ProductContext.Provider>
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ADIRecentlyViewedProductGridCard);
